export const opTags = [
  { id: 1, name: "pts", status: null },
  { id: 2, name: "bush brothers ", status: null },
  { id: 3, name: "mansfield", status: null },
  { id: 4, name: "one to one", status: null },
  { id: 5, name: "vmi analyst", status: null },
  { id: 6, name: "ergon refining", status: null },
];
